import { render, staticRenderFns } from "./TextCustomBlock.vue?vue&type=template&id=59713cc7"
import script from "./TextCustomBlock.vue?vue&type=script&lang=js"
export * from "./TextCustomBlock.vue?vue&type=script&lang=js"
import style0 from "./TextCustomBlock.vue?vue&type=style&index=0&id=59713cc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports